import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import AppLink from '../../../routing/helpers/AppLink';

const Breadcrumb = () => {
  const breadcrumb = useSelector((state) => state.global.breadcrumb);
  const user = useSelector((state) => state.auth?.user);
  const doubleAuth = useSelector(
    (state) => state?.auth?.permissions?.client?.global?.doubleAuth
  );
  const [isForceChangePassword] = useState(
    user?.isForceChangePassword === true
  );
  const [isForceDoubleAuth] = useState(
    doubleAuth?.force === true && !user?.googleAuthenticatorSecret
  );
  const [route, setRoute] = useState('user_home');

  useEffect(() => {
    if (isForceChangePassword) {
      setRoute('user_change_password');
    } else if (isForceDoubleAuth) {
      setRoute('user_double_auth');
    }
  }, []);

  if (!breadcrumb) {
    return <div style={{ height: '21px', marginBottom: '1.5rem' }} />;
  }

  return (
    <div className="row mb-2 ml-2">
      <div className="col-sm-12">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <AppLink path={route}>
              <AppRemixIcon icon="home" />
            </AppLink>
          </li>
          {breadcrumb.map((c, i) => (
            <li className="breadcrumb-item" key={i}>
              {c.route ? (
                c.isOld ? (
                  <a href={c.route}>{c.name}</a>
                ) : (
                  <Link as="a" to={c.route}>
                    {c.name}
                  </Link>
                )
              ) : (
                c.name
              )}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default Breadcrumb;
